import * as defaultState from '../constants/DefaultState';

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('wafState');
    if (serializedState === null || serializedState === undefined) {
      return defaultState.defaultState;
    }
    return JSON.parse(serializedState).webAppointmentForm;
  }
  catch (err) {
    return defaultState.defaultState;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('wafState', serializedState);
  }
  catch (err) {
    console.log("saving state to sessionStorage failed.");
    console.log(err);
  }
};

export const clearState = () => {
  if (sessionStorage.getItem('wafState')) {
    sessionStorage.removeItem('wafState');
	}
};